// Port of api/fuel/app/classes/controller/api/monty/groups/leave.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import { currentUser, groupPayload, invalid, persist, recountGroupUsers, recountUserGroups, resolveGroup, touchGroup } from './shared'

export default function(params) {
	var user = currentUser(params)
	var group = resolveGroup(params)
	if (!user || !group) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (user.get_id() === group.get_user_id()) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (group.get_type() !== Constants.GROUP_TYPE_STANDARD) return invalid(Constants.API_ERROR_UNAUTHORISED)

	var existing = DB.query('SELECT link_id FROM link_group_user WHERE group_id = ? AND user_id = ?', [group.get_id(), user.get_id()])
	if (!existing.length) return invalid(Constants.API_ERROR_USER_NOTINGROUP)

	DB.run('DELETE FROM link_group_user WHERE group_id = ? AND user_id = ?', [group.get_id(), user.get_id()])
	touchGroup(group.get_id())
	recountGroupUsers(group.get_id())
	recountUserGroups(user.get_id())

	return persist({
		group: groupPayload(group.get_id())
	})
}
